var RSVP = require('rsvp');
var URI = require('URIjs');
var URITemplate = require('URIjs/src/URITemplate');

(function () {
    if (typeof String.prototype.endsWith !== 'function') {
        String.prototype.endsWith = function (suffix) {
            return this.indexOf(suffix, this.length - suffix.length) !== -1;
        };
    }

    if (typeof String.prototype.startsWith !== 'function') {
        String.prototype.startsWith = function (str) {
            return this.slice(0, str.length) === str;
        };
    }
})();

(function (window) {
    if (!window.JSON) {
        throw new Error("Octopus.Client: No JSON parser found. Please ensure json2.js is referenced before the Octopus.Client.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
    }

    if (!RSVP) {
        throw new Error("Octopus.Client: RSVP.js not found. Please ensure RSVP.js is referenced before the Octopus.Client.js file.");
    }

    if (!window.jQuery) {
        throw new Error("Octopus.Client: jQuery was not found. Please ensure jQuery is referenced before the Octopus.Client.js file.");
    }

    var Octopus = window.Octopus = window.Octopus || {};
    var noOp = function () {
        return this;
    };

    var jQuery = window.jQuery;

    Octopus.Client = {};

    Octopus.Client.PromiseWrapper = function (callback) {
        return new RSVP.Promise(callback);
    };

    Octopus.Client.Logger = (function () {
        var instance = {};
        instance.isEnabled = true;

        var consoleWrapper = function (name) {
            var console = window.console;
            if (console && console[name]) {
                if (console[name].apply) {
                    return function () {
                        if (instance.isEnabled) {
                            console[name].apply(console, arguments);
                        }
                    };
                } else {
                    return function () {
                        if (instance.isEnabled) {
                            var message = Array.prototype.join.call(arguments, ', ');
                            console[name](message);
                        }
                    };
                }
            }
        };

        instance.log = consoleWrapper('log') || noOp();
        instance.info = consoleWrapper('info') || noOp();
        instance.warn = consoleWrapper('warn') || noOp();
        instance.error = consoleWrapper('error') || noOp();
        instance.error = consoleWrapper('error') || noOp();
        instance.enabled = function (b) {
            if (typeof (b) !== "undefined") {
                instance.isEnabled = b;
            }
            return instance.isEnabled;
        };
        return instance;
    })();

    Octopus.Client.Util = {};
    Octopus.Client.Util.extend = function () {
        return jQuery.extend(arguments[0], arguments[1]);
    };

    // We use our own AJAX function so that we're not too coupled to jQuery
    Octopus.Client.Util.ajax = (function () {
        var XMLHttpFactories = [
            function () {
                return new XMLHttpRequest();
            },
            function () {
                return new ActiveXObject("Msxml2.XMLHTTP");
            },
            function () {
                return new ActiveXObject("Msxml3.XMLHTTP");
            },
            function () {
                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
            },
            function () {
                return new ActiveXObject("Microsoft.XMLHTTP");
            }
        ];

        return function (options2) {
            var createXMLHTTPObject = function () {
                var xmlhttp = false;
                for (var i = 0; i < XMLHttpFactories.length; i++) {
                    try {
                        xmlhttp = XMLHttpFactories[i]();
                    }
                    catch (e) {
                        continue;
                    }
                    break;
                }
                return xmlhttp;
            };

            var defaults = {
                method: "GET",
                uri: null,
                nonStale: true,
                requestBody: null,
                requestBodyContentType: null,
                raw: false,
                success: function (data) {
                },
                error: function (xhr) {
                }
            };

            var options = Octopus.Client.Util.extend(defaults, options2);

            var request = createXMLHTTPObject();
            if (!request) {
                return;
            }

            var methodOverride = null;
            var method = options.method;
            if (method === 'PUT') {
                methodOverride = 'PUT';
                method = 'POST';
            }
            if (method === 'DELETE') {
                methodOverride = 'DELETE';
                method = 'POST';
            }

            request.open(method, options.url, true);

            request.withCredentials = true;

            request.setRequestHeader('X-Octopus-User-Agent', 'OctopusClient-js/' + Octopus.Version);

            //request.setRequestHeader('Cache-Control', 'no-cache');
            request.setRequestHeader('Accept', 'application/json');
            if (options.requestBody) {
                request.setRequestHeader('Content-type', 'application/json');
            }

            if (methodOverride) {
                request.setRequestHeader('X-HTTP-Method-Override', methodOverride);
            }

            var httpCache = Octopus.Client.Util.ajax.cache;

            var cachedResult = httpCache.setHeaderAndGetValue(request, options);

            // Set X-Octopus-Csrf-Token header if there is an antiforgery cookie available and it's a mutating request
            if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
                var antiforgeryToken = Octopus.Client.Util.getAntiforgeryToken();
                if (antiforgeryToken) {
                    request.setRequestHeader('X-Octopus-Csrf-Token', antiforgeryToken);
                }
            }

            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }

                var deserialize = function (responseText, forceJson) {
                    if (options.raw && ((typeof forceJson === 'undefined') || !forceJson)) {
                        return responseText;
                    }

                    if (responseText && responseText.length) {
                        return JSON.parse(responseText);
                    }

                    return null;
                };

                if (request.status < 100 || request.status >= 400) {
                    var error = null;

                    try {
                        if (request.status === 0) {
                            error = {
                                ErrorMessage: "There was a problem with your request.",
                                FullException: null,
                                Errors: ["Unable to establish a connection to the Octopus Deploy server. The server may be offline. Please check your network connection."]
                            };
                        } else {
                            error = deserialize(request.responseText, true);

                            if (!error.ErrorMessage) {
                                error = {
                                    ErrorMessage: "There was a problem with your request.",
                                    FullException: request.response,
                                    Errors: ["The Octopus Deploy server returned a status of: " + request.status]
                                };
                            }
                        }
                    }
                    catch (err) {
                        error = {
                            ErrorMessage: "There was a problem with your request.",
                            FullException: err.toString(),
                            Errors: ["Unhandled error when communicating with the Octopus Deploy server. The server returned a status of: " + request.status]
                        };
                    }

                    error.StatusCode = request.status;

                    if (typeof Octopus.Client.Util.ajax.error === 'function') {
                        Octopus.Client.Util.ajax.error(error);
                    }

                    options.error(error);
                    return;
                }

                var responseBody = cachedResult;
                if(!responseBody || !httpCache.canUseCachedValue(request)){
                    responseBody = request.responseText
                    httpCache.updateCache(request, options);
                }
                options.success(deserialize(responseBody));
            };

            if (request.readyState === 4) {
                return;
            }

            if (typeof Octopus.Client.Util.ajax.beforeRequest === 'function') {
                if (!Octopus.Client.Util.ajax.beforeRequest(request)) {
                    Octopus.Client.Logger.log('Canceled request', request);
                    return;
                }
            }

            var body = options.requestBody;
            if (typeof (body) === "undefined") {
                request.send();
            } else if (typeof (body) === "string") {
                request.send(body);
            } else {
                var bodyJson = JSON.stringify(body);
                request.send(bodyJson);
            }
        };
    })();

    // This function can be overriden to allow inspection or customization of the request before it is sent
    Octopus.Client.Util.ajax.beforeRequest = function (request) {
        return true;
    };

    // This function can be overriden to allow intercepting and handling of ajax errors
    Octopus.Client.Util.ajax.error = function (error) {

    };

    Octopus.Client.Util.getAntiforgeryToken = function() {
        // I'm not a fan of the static reference to Octopus.App.Client to get the rootDocument(), but not too sure how best to make this work otherwise
        if (!Octopus.App.Client || !Octopus.App.Client.isConnected()) {
            return null;
        }

        var installationId = Octopus.App.Client.rootDocument().InstallationId;
        if (!installationId) {
            return null;
        }

        // If we have come this far we know we are on a version of Octopus Server which supports anti-forgery tokens
        var antiforgeryCookieName = 'Octopus-Csrf-Token_' + installationId;
        var antiforgeryCookies;
        antiforgeryCookies = document.cookie.split(';').filter(function (c) {
            return c.trim().indexOf(antiforgeryCookieName) === 0;
        }).map(function (c) {
            return c.trim();
        });

        if (antiforgeryCookies && antiforgeryCookies.length === 1) {
            var antiforgeryToken = antiforgeryCookies[0].split('=')[1];
            return antiforgeryToken;
        } else {
            return null;
        }
    };

    // The Resolver is used to take URI's like "/api/foo/bar" and turn them into fully qualified URI's depending on the Octopus
    // server we are talking to (e.g., http://your-octopus/api/foo/bar or perhaps even, http://your-octopus/vdir1/vdir2/api/foo/bar).
    Octopus.Client.Resolver = function (baseUri) {
        baseUri = baseUri.endsWith('/') ? baseUri : baseUri + "/";

        var lastIndexOfMandatorySegment = baseUri.lastIndexOf('/api/');
        if (lastIndexOfMandatorySegment >= 1) {
            baseUri = baseUri.substring(0, lastIndexOfMandatorySegment);
        } else if (baseUri.endsWith('/api')) {
            baseUri = baseUri.substring(0, -4);
        }

        baseUri = baseUri.endsWith('/') ? baseUri.substring(0, baseUri.length - 1) : baseUri;

        var parsed = URI(baseUri);
        var rootUri = parsed.scheme() + "://" + parsed.authority();
        rootUri = rootUri.endsWith('/') ? rootUri.substring(0, rootUri.length - 1) : rootUri;

        this.resolve = function (path, uriTemplateParameters) {
            if (!path) {
                throw 'The link does not exist';
            }

            if (path.startsWith("~/")) {
                path = path.substring(1, path.length);
                path = baseUri + path;
            } else {
                path = rootUri + path;
            }

            var template = new URITemplate(path);
            var result = template.expand(uriTemplateParameters || {});

            return result;
        };
    };

    // The Octopus Client implements the low-level semantics of the Octopus Deploy REST API
    Octopus.Client.OctopusClient = function (configuration) {
        var defaultConfiguration = {
            serverEndpoint: null
        };

        configuration = Octopus.Client.Util.extend(defaultConfiguration, configuration);

        var endpoint = configuration.serverEndpoint;
        if (endpoint == null || endpoint.length === 0) {
            endpoint = "" + window.location.protocol;
            if (!endpoint.endsWith("//")) {
                endpoint = endpoint + "//";
            }

            endpoint = endpoint + window.location.host;

            var path = window.location.pathname;
            if (!path.startsWith("/")) {
                path = "/" + path;
            }

            if (path.length >= 1) {
                var lastSegmentIndex = path.lastIndexOf("/");
                if (lastSegmentIndex >= 0) {
                    path = path.substring(0, lastSegmentIndex + 1);
                }
            }

            endpoint = endpoint + path;
        }

        Octopus.Client.Logger.log("Creating Octopus client for endpoint: " + endpoint);

        var currentResolver = new Octopus.Client.Resolver(endpoint);

        var dispatchRequest = function (method, url, requestBody) {
            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
                Octopus.Client.Util.ajax({
                    method: method,
                    url: url,
                    requestBody: requestBody,
                    success: function (result) {
                        resolve(result);
                    },
                    error: function (error) {
                        reject(error);
                    }
                });
            });
        };

        this.urlStripHostAndPort = function(location) {
            var parser = document.createElement('a');
            if(typeof location.absUrl === 'function') {
                parser.href = location.absUrl();
            } else {
                parser.href = location;
            }
            var path = parser.pathname;
            if(path[0] !== '/') {
                path = '/' + path;
            }
            
            return path + parser.hash;
        };

        this.uiRelativeRootPath = function(location) {
            return this.urlStripHostAndPort(location).replace(location.path(), '');
        };

        this.urlIndicatesNonDevelopmentMode = function(absUrl, apiUrl) {
            // In our Nancy localhost:9005 dev world, the absolute url on :9005 won't start with the api url on :8065.
            return absUrl.startsWith(apiUrl);
        };

        this.resolve = currentResolver.resolve;
        this.resolveLinkTemplate = function(link, args) {
            return this.resolve(this.rootDocument().Links[link], args);
        };

        this.get = function (path, args) {
            var url = currentResolver.resolve(path, args);
            return dispatchRequest("GET", url);
        };

        this.getRaw = function (path, args) {
            var url = currentResolver.resolve(path, args);

            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
                Octopus.Client.Util.ajax({
                    method: 'GET',
                    url: url,
                    raw: true,
                    success: function (result) {
                        resolve(result);
                    },
                    error: function (error) {
                        reject(error);
                    }
                });
            });
        };

        this.post = function (path, resource) {
            var url = currentResolver.resolve(path);
            return dispatchRequest("POST", url, resource);
        };

        this.create = function (path, resource, args) {
            var url = currentResolver.resolve(path, args);

            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
                dispatchRequest("POST", url, resource)
                    .then(function (result) {
                        dispatchRequest("GET", currentResolver.resolve(result.Links["Self"]))
                            .then(function (result2) {
                                resolve(result2);
                            }, reject);
                    }, reject);
            });
        };

        this.update = function (path, resource, args) {
            var url = currentResolver.resolve(path, args);

            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
                dispatchRequest("PUT", url, resource)
                    .then(function () {
                        dispatchRequest("GET", url)
                            .then(function (result2) {
                                resolve(result2);
                            }, reject);
                    }, reject);
            });
        };

        this.del = function (path, resource, args) {
            var url = currentResolver.resolve(path, args);
            return dispatchRequest("DELETE", url, resource);
        };

        this.put = function (path, resource) {
            var url = currentResolver.resolve(path);
            return dispatchRequest("PUT", url, resource);
        };

        this._rootDocument = null;

        this.rootDocument = function () {
            if (!this.isConnected()) {
                throw new Error('The Octopus Client has not connected.');
            }

            return this._rootDocument;
        };

        this.isConnected = function () {
            return this._rootDocument !== null;
        };

        this.connect = function (progressCallback) {
            var that = this;

            progressCallback("Checking your credentials. Please wait...", '');

            return Octopus.Client.PromiseWrapper(function (resolve, reject) {
                if (that._rootDocument !== null) {
                    resolve(that._rootDocument);
                }

                var attempt = function (success, fail) {
                    that.get("~/api")
                        .then(success, fail);
                };

                var onSuccess = function (root) {
                    that._rootDocument = root;
                    Octopus.Version = root.Version;
                    resolve(that._rootDocument);
                };

                var fails = 0;
                var onFail = function (err) {
                    if (err.StatusCode !== 503) {
                        fails++;
                    }

                    if ((err.StatusCode === 0 || err.StatusCode === 503) && fails < 20) {
                        Octopus.Client.Logger.warn("Unable to connect, trying again in 1 second...", err);

                        if (err.StatusCode === 503) {
                            progressCallback(err.ErrorMessage, 'success');
                        } else if (err.StatusCode === 0) {
                            progressCallback("The Octopus server does not appear to have started, trying again...", 'warning');
                        }

                        setTimeout(function () {
                            Octopus.Client.Logger.warn("Trying again", err);
                            attempt(onSuccess, onFail);
                        }, 1000);
                    } else {
                        Octopus.Client.Logger.error("Unable to connect, unexpected error, or timeout exceeded", err);
                        reject(err);
                    }
                };

                attempt(onSuccess, onFail);
            });
        };
    };

    // Repositories provide a helpful abstraction around the Octopus Deploy API
    Octopus.Client.Repository = function (client) {

        this.resolve = client.resolve;
        this.resolveLinkTemplate = client.resolveLinkTemplate;

        var BasicRepository = function (collectionLinkName) {
            var self = this;

            self.create = function (resource, args) {
                return client.create(client.rootDocument().Links[collectionLinkName], resource, args);
            };

            self.modify = function (resource, args) {
                return client.update(resource.Links["Self"], resource, args);
            };

            self.del = function (resource) {
                return client.del(resource.Links["Self"]);
            };

            self.list = function (args) {
                return client.get(client.rootDocument().Links[collectionLinkName], args);
            };

            self.get = function (id, args) {
                var allArgs = Octopus.Client.Util.extend(args || {}, {id: id});
                return client.get(client.rootDocument().Links[collectionLinkName], allArgs);
            };

            self.all = function (args) {
                if (args !== undefined && args.ids instanceof Array && args.ids.length === 0) {
                    return Octopus.Client.PromiseWrapper(function(res) { res([]); });
                }

                var allArgs = Octopus.Client.Util.extend(args || {}, {id: 'all'});
                return client.get(client.rootDocument().Links[collectionLinkName], allArgs);
            };

            self.save = function (resource, args) {
                if (resource.Links && resource.Id) {
                    return self.modify(resource, args);
                } else {
                    return self.create(resource, args);
                }
            };
        };

        var hasRootLink = function (rootLink, repository) {
            return !!client.rootDocument().Links[rootLink];
        };

        this.Users = Octopus.Client.Util.extend(new BasicRepository("Users"), {
            signIn: function (loginCommand) {
                return client.post(client.rootDocument().Links["SignIn"], loginCommand).then(function(authenticatedUser) {
                    var antiforgeryToken = Octopus.Client.Util.getAntiforgeryToken();

                    if (antiforgeryToken) {
                        return authenticatedUser;
                    }
                    else {
                        throw 'The required anti-forgery cookie is missing. Perhaps your browser or another network device is blocking cookies? See http://g.octopushq.com/CSRF for more details and troubleshooting.';
                    }
                });
            },

            signOut: function () {
                return client.post(client.rootDocument().Links["SignOut"], {});
            },

            getCurrent: function () {
                return client.get(client.rootDocument().Links["CurrentUser"]);
            },

            getPermissions: function (user) {
                return client.get(user.Links["Permissions"]);
            },

            createApiKey: function (user, purpose) {
                return client.post(user.Links["ApiKeys"], {Purpose: purpose});
            },

            listApiKeys: function (user) {
                return client.get(user.Links["ApiKeys"]);
            },

            revokeApiKey: function (apiKey) {
                return client.del(apiKey.Links["Self"]);
            },

            invite: function (teamIds) {
                return client.post(client.rootDocument().Links["Invitations"], {AddToTeamIds: teamIds});
            },

            register: function (registerCommand) {
                return client.post(client.rootDocument().Links["Register"], registerCommand);
            },

            getTriggers: function (user) {
                return client.get(user.Links["Triggers"]);
            },
        });

        this.Licenses = Octopus.Client.Util.extend(new BasicRepository("Licenses"), {
            getCurrent: function () {
                return client.get(client.rootDocument().Links["CurrentLicense"]);
            },
            getCurrentStatus: function() {
                return client.get(client.rootDocument().Links["CurrentLicenseStatus"])
            }
        });

        this.Dashboards = {
            getDashboard: function (dashboardFilter) {
                return client.get(client.rootDocument().Links["Dashboard"], dashboardFilter);
            },

            getProjectDashboard: function (project) {
                return client.get(client.rootDocument().Links["DashboardDynamic"], {
                    projects: project.Id,
                    includePrevious: true
                });
            },

            getMiniboard: function (project, environment) {
                return client.get(client.rootDocument().Links["DashboardDynamic"], {
                    projects: project,
                    environments: environment,
                    includePrevious: false
                });
            }
        };

        this.DashboardConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["DashboardConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            }
        };

        this.SmtpConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["SmtpConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            }
        };

        this.MaintenanceConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["MaintenanceConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            }
        };

        this.FeaturesConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["FeaturesConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            }
        };

        this.ServerConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["ServerConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            },
            settings: function () {
                return client.get(client.rootDocument().Links["ServerConfigurationSettings"]);
            }
        };

        this.ServerStatus = {
            getServerStatus: function () {
                return client.get(client.rootDocument().Links["ServerStatus"]);
            },
            getLogs: function (status) {
                return client.get(status.Links["RecentLogs"]);
            },
            getSystemInfo: function (status) {
                return client.get(status.Links["SystemInfo"]);
            },
            getBuiltInFeedStats: function (status) {
                return client.get(status.Links["BuiltInFeedStats"]);
            },
            gcCollect: function (status) {
                return client.post(status.Links["GCCollect"], status);
            },
            getExtensionStats: function () {
                return client.get(client.rootDocument().Links["ExtensionStats"]);
            },
            getTimezones: function () {
                return client.get(client.rootDocument().Links["Timezones"]);
            }
        };

        this.Accounts = Octopus.Client.Util.extend(new BasicRepository("Accounts"), {
            getWebSites: function (account) {
                return client.get(account.Links["WebSites"]);
            },
            getCloudServices: function (account) {
                return client.get(account.Links["CloudServices"]);
            },
            getStorageAccounts: function (account) {
                return client.get(account.Links["StorageAccounts"]);
            },
            getResourceGroups: function (account) {
                return client.get(account.Links["ResourceGroups"]);
            },
            getFabricApplications: function (account) {
                return client.get(account.Links["FabricApplications"]);
            }
        });

        this.Progression = {
            getProgression: function (project, options) {
                return client.get(project.Links["Progression"], options);
            }
        };

        this.Backups = {
            getConfiguration: function () {
                return client.get(client.rootDocument().Links["BackupConfiguration"]);
            },
            updateConfiguration: function (configuration) {
                return client.update(configuration.Links["Self"], configuration);
            }
        };

        this.PermissionDescriptions = {
            all: function () {
                return client.get(client.rootDocument().Links["PermissionDescriptions"], null);
            }
        };

        this.ActionTemplates = Octopus.Client.Util.extend(new BasicRepository("ActionTemplates"), {
            getUsage: function (template) {
                return client.get(template.Links["Usage"]);
            },
            getByCommunityTemplate : function (communityTemplate) {
                var allArgs = Octopus.Client.Util.extend({}, {id: communityTemplate.id});
                return client.get(communityTemplate.Links["InstalledTemplate"], allArgs);
            },
            search: function () {
                return client.get(client.rootDocument().Links["ActionTemplatesSearch"]);
            },
            updateActions: function (actionTemplate, actionIdsByProcessId, defaults, overrides) {
                var defaults = defaults || {};
                var overrides = overrides || {};
                return client.post(actionTemplate.Links["ActionsUpdate"], {
                    version: actionTemplate.Version,
                    actionIdsByProcessId: actionIdsByProcessId,
                    defaultPropertyValues: defaults,
                    overrides: overrides
                });
            },
            getVersion: function (actionTemplate, version) {
                return client.get(actionTemplate.Links["Versions"], {version: version});
            }
        });

        this.Alerts = Octopus.Client.Util.extend(new BasicRepository("Alerts"), {});

        this.Tasks = Octopus.Client.Util.extend(new BasicRepository("Tasks"), {
            getDetails: function (task, options) {
                return client.get(task.Links["Details"], options);
            },
            getQueuedBehind: function (task, options) {
                return client.get(task.Links["QueuedBehind"], options);
            },
            getRaw: function (task) {
                return client.getRaw(task.Links["Raw"]);
            },

            filter: function (options) {
                return client.get(client.rootDocument().Links["Tasks"], options);
            },

            rerun: function (task) {
                return client.post(task.Links["Rerun"]);
            },

            cancel: function (task) {
                return client.post(task.Links["Cancel"]);
            },

            changeState: function (task, state, reason) {
                return client.post(task.Links["State"], {state: state, reason: reason});
            }
        });

        this.Packages = Octopus.Client.Util.extend(new BasicRepository("Packages"), {
            deleteMany: function (packageIds) {
                return client.del(client.rootDocument().Links["PackagesBulk"], null, {ids: packageIds});
            },
            getUploadUrl: function (uploadOptions) {
                return client.resolve(client.rootDocument().Links["PackageUpload"], uploadOptions);
            }
        });

        this.ExternalSecurityGroupProviders = {
            all: function () {
                return client.get(client.rootDocument().Links["ExternalSecurityGroupProviders"]);
            }
        };

        this.ExternalSecurityGroups = {
            search: function (url, name) {
                return client.get(url, {partialName: name});
            }
        };

        this.ExternalUsers = {
            search: function (partialName) {
                return client.get(client.rootDocument().Links["ExternalUserSearch"], {partialName: partialName});
            },
            searchProvider: function (providerUrl, partialName) {
                return client.get(providerUrl, {partialName: partialName});
            }
        };

        this.UserIdentityMetadata = {
            all: function () {
                return client.get(client.rootDocument().Links["UserIdentityMetadata"]);
            }
        };

        this.PackageRepository = {
            getConfiguration: function () {
                return client.get(client.rootDocument().Links["RepositoryConfiguration"]);
            },
            updateConfiguration: function (configuration) {
                return client.update(configuration.Links["Self"], configuration);
            }
        };

        this.Projects = Octopus.Client.Util.extend(new BasicRepository("Projects"), {
            getDeployments: function (project) {
                return client.get(client.rootDocument().Links["Deployments"], {projects: project.Id});
            },

            getReleases: function (project, args) {
                return client.get(project.Links["Releases"], args);
            },

            getReleaseByVersion: function (project, version) {
                return client.get(project.Links["Releases"], {version: version});
            },

            listByGroup: function (projectGroup) {
                return client.get(projectGroup.Links["Projects"]);
            },

            getChannels: function (project) {
                return client.get(project.Links["Channels"]);
            },

            getTriggers: function (project) {
                return client.get(project.Links["Triggers"]);
            },

            orderChannels: function (project, channelIds) {
                return client.post(project.Links["OrderChannels"], channelIds);
            },

            getPulse: function (projects) {
                var projectIds = _.map(projects, function (p) {
                    return p.Id;
                }).join(',');
                return client.get(client.rootDocument().Links["ProjectPulse"], {projectIds: projectIds});
            }
        });

        this.ProjectGroups = Octopus.Client.Util.extend(new BasicRepository("ProjectGroups"), {});

        this.Lifecycles = Octopus.Client.Util.extend(new BasicRepository("Lifecycles"), {
            preview: function (lifecycle) {
                return client.get(lifecycle.Links["Preview"]);
            },
            projects: function (lifecycle) {
                return client.get(lifecycle.Links["Projects"]);
            }
        });

        this.MachinePolicies = Octopus.Client.Util.extend(new BasicRepository("MachinePolicies"), {
            getMachines: function (machinePolicy) {
                return client.get(machinePolicy.Links["Machines"]);
            }
        });

        this.RetentionPolicies = Octopus.Client.Util.extend(new BasicRepository("RetentionPolicies"), {});

        this.Environments = Octopus.Client.Util.extend(new BasicRepository("Environments"), {
            sort: function (order) {
                return client.put(client.rootDocument().Links["EnvironmentSortOrder"], order);
            },
            variablesScopedOnlyToThisEnvironment: function (environment) {
                return client.get(environment.Links["SinglyScopedVariableDetails"]);
            }
        });

        this.Machines = Octopus.Client.Util.extend(new BasicRepository("Machines"), {
            listByEnvironment: function (environment) {
                return client.get(environment.Links["Machines"]);
            },
            discover: function (host, port, type, proxyId) {
                return client.get(client.rootDocument().Links["DiscoverMachine"], {host: host, port: port, type: type, proxyId: proxyId});
            },
            getConnectionStatus: function (machine) {
                return client.get(machine.Links["Connection"]);
            },
            getTasks: function (machine, options) {
                return client.get(machine.Links["TasksTemplate"], options);
            },
            hosted: function () {
                var allArgs = {id: 'hosted'};
                return client.get(client.rootDocument().Links["Machines"], allArgs);
            },
            listByDeployment: function (deployment) {
                return client.get(client.rootDocument().Links["Machines"], {id: 'all', deploymentId: deployment.Id});
            }
        });

        this.UserRoles = Octopus.Client.Util.extend(new BasicRepository("UserRoles"), {});

        this.MachineRoles = {
            all: function () {
                return client.get(client.rootDocument().Links["MachineRoles"]);
            }
        };

        this.Defects = {
            all: function (release) {
                return client.get(release.Links["Defects"]);
            },
            report: function (release, description) {
                return client.post(release.Links["ReportDefect"], {Description: description});
            },
            resolve: function (release) {
                return client.post(release.Links["ResolveDefect"]);
            }
        };

        this.Releases = Octopus.Client.Util.extend(new BasicRepository("Releases"), {
            getDeployments: function(release, skip) {
                return client.get(release.Links["Deployments"], {skip: skip || 0});
            },
            getDeploymentTemplate: function (release) {
                return client.get(release.Links["DeploymentTemplate"]);
            },
            getDeploymentPreview: function (promotionTarget) {
                return client.get(promotionTarget.Links["Preview"], {includeDisabledSteps: true});
            },
            progression: function (release) {
                return client.get(release.Links["Progression"]);
            },
            snapshotVariables: function (release) {
                return client.post(release.Links["SnapshotVariables"]);
            }
        });

        this.Deployments = Octopus.Client.Util.extend(new BasicRepository("Deployments"), {});

        this.Feeds = Octopus.Client.Util.extend(new BasicRepository("Feeds"), {
            getVersions: function (feed, packageIds) {
                return client.get(feed.Links["VersionsTemplate"], {packageIds: packageIds});
            },
            search: function (feed, searchOptions) {
                return client.get(feed.Links["SearchTemplate"], searchOptions);
            },
            getNotes: function (feed, packageId, version) {
                return client.getRaw(feed.Links["NotesTemplate"], {packageId: packageId, version: version});
            }
        });

        this.Artifacts = Octopus.Client.Util.extend(new BasicRepository("Artifacts"), {
            list: function (options) {
                return client.get(client.rootDocument().Links["Artifacts"], options);
            }
        });

        this.Events = Octopus.Client.Util.extend(new BasicRepository("Events"), {
            list: function (options) {
                return client.get(client.rootDocument().Links["Events"], options);
            },
            categories: function (options) {
                return client.get(client.rootDocument().Links["EventCategories"], options);
            },
            groups: function (options) {
                return client.get(client.rootDocument().Links["EventGroups"], options);
            },
            documentTypes: function (options) {
                return client.get(client.rootDocument().Links["EventDocumentTypes"], options);
            }
        });

        this.Interruptions = Octopus.Client.Util.extend(new BasicRepository("Interruptions"), {
            list: function (options) {
                return client.get(client.rootDocument().Links["Interruptions"], options);
            },
            submit: function (interruption, result) {
                return client.post(interruption.Links["Submit"], result);
            },
            takeResponsibility: function (interruption) {
                return client.put(interruption.Links["Responsible"]);
            }
        });

        this.Variables = Octopus.Client.Util.extend(new BasicRepository("Variables"), {
            names: function (projectId, projectEnvironmentsFilter) {
                return client.get(client.rootDocument().Links["VariableNames"], {
                    project: projectId,
                    projectEnvironmentsFilter: projectEnvironmentsFilter ? projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
                });
            },
            nonPrintableChars: function (variableSet) {
                return client.post(client.rootDocument().Links["VariablesNonPrintableChars"], variableSet);
            }
        });

        this.DeploymentProcesses = Octopus.Client.Util.extend(new BasicRepository("DeploymentProcesses"), {
            getTemplate: function (deploymentProcess, channelId, releaseId) {
                return client.get(deploymentProcess.Links["Template"], {channel: channelId, releaseId: releaseId});
            }
        });

        this.Reporting = {
            getDeploymentsCountedByWeek: function (projectIds) {
                return client.get(client.rootDocument().Links["Reporting/DeploymentsCountedByWeek"], {projectIds: projectIds.join(",")});
            }
        };

        this.Teams = Octopus.Client.Util.extend(new BasicRepository("Teams"), {});

        this.CertificateConfiguration = Octopus.Client.Util.extend(new BasicRepository("CertificateConfiguration"), {
            getOctopusCertificate: function () {
                return this.get('certificate-global');
            },
            getAzureCertificate: function () {
                return this.get('certificate-azure');
            }
        });

        this.LetsEncryptConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["LetsEncryptConfiguration"]);
            },
            disable: function(resource) {
                return client.post(resource.Links["Disable"]);
            }
        };

        this.Proxies = Octopus.Client.Util.extend(new BasicRepository("Proxies"), {});

        this.Certificates = Octopus.Client.Util.extend(new BasicRepository("Certificates"), {
            export: function(certificate, exportOptions) {
                return client.get(certificate.Links['Export'], exportOptions);
            },
            archive: function(certificate) {
                return client.post(certificate.Links['Archive']);
            },
            unarchive: function(certificate) {
                return client.post(certificate.Links['Unarchive']);
            },
            usage: function(certificate) {
                return client.get(certificate.Links['Usage']);
            },
            replace: function(certificate, newCertificateData, newPassword) {
               return client.post(certificate.Links['Replace'], {
                   certificateData: newCertificateData,
                   password: newPassword
               });
            }
        });

        this.LibraryVariableSets = Octopus.Client.Util.extend(new BasicRepository("LibraryVariables"), {});

        this.OctopusServerNodes = Octopus.Client.Util.extend(new BasicRepository("OctopusServerNodes"), {});

        this.Channels = Octopus.Client.Util.extend(new BasicRepository("Channels"), {
            ruleTest: function (version, searchOptions) {
                return client.post(client.rootDocument().Links["VersionRuleTest"], {
                    version: version,
                    versionRange: searchOptions.versionRange,
                    preReleaseTag: searchOptions.preReleaseTag
                });
            },
            getReleases: function (channel, options) {
                return client.get(channel.Links["Releases"], options);
            }
        });

        this.UpgradeConfiguration = {
            get: function () {
                return client.get(client.rootDocument().Links["UpgradeConfiguration"]);
            },
            modify: function (resource) {
                return client.update(resource.Links["Self"], resource);
            }
        };

        this.UserOnboarding = {
            get: function () {
                return client.get(client.rootDocument().Links["UserOnboarding"]);
            }
        };


        if (hasRootLink("Tenants")) {
            this.Tenants = Octopus.Client.Util.extend(new BasicRepository("Tenants"), {
                tagTest: function (tenantIds, tags) {
                    return client.get(client.rootDocument().Links["TenantTagTest"], {tenantIds: tenantIds, tags: tags});
                },
                getVariables: function (tenant) {
                    return client.get(tenant.Links["Variables"]);
                },
                setVariables: function (tenant, variables) {
                    return client.put(tenant.Links["Variables"], variables);
                },
                missingVariables: function (filterOptions, includeDetails) {
                    if (filterOptions === false || filterOptions === true) {
                        includeDetails = filterOptions;
                    }
                    filterOptions = filterOptions || {};
                    var payload = {
                        tenantId: filterOptions.tenantId,
                        projectId: filterOptions.projectId,
                        environmentId: filterOptions.environmentId,
                        includeDetails: !!includeDetails
                    };
                    return client.get(client.rootDocument().Links["TenantsMissingVariables"], payload);
                }
            });
        }

        if (hasRootLink("TenantVariables")) {
            this.TenantVariables = Octopus.Client.Util.extend(new BasicRepository("TenantVariables"), {});
        }

        if (hasRootLink("TagSets")) {
            this.TagSets = Octopus.Client.Util.extend(new BasicRepository("TagSets"), {
                sort: function (tagSet) {
                    return client.put(client.rootDocument().Links["TagSetSortOrder"], tagSet);
                }
            });
        }

        this.ProjectTriggers = Octopus.Client.Util.extend(new BasicRepository("ProjectTriggers"), {});

        this.Subscriptions = Octopus.Client.Util.extend(new BasicRepository("Subscriptions"), {});

        this.Scheduler = Octopus.Client.Util.extend(new BasicRepository("Scheduler"), {
            getDetails: function (name, options) {
                return client.get(client.rootDocument().Links["Scheduler"], {
                    name: name,
                    verbose: options.verbose,
                    tail: options.tail
                });
            }
        });

        this.CommunityActionTemplates = {
            get : function (id) {
                var allArgs = Octopus.Client.Util.extend({}, {id: id});
                return client.get(client.rootDocument().Links["CommunityActionTemplates"], allArgs);
            },
            install : function (communityActionTemplate) {
                return client.post(communityActionTemplate.Links["Installation"]);
            },
            updateInstallation : function (communityActionTemplate) {
                return client.put(communityActionTemplate.Links["Installation"]);
            }
        };
    };

    Octopus.Client.HttpCaching = function(options) {
        options = options || {};
        var self = this;

        var maxMemory = options.maxMemory || Math.pow(1024,2) * 100 / 2; //100MB /2 (1 character in js is 2 bytes)
        var cleanupInterval = options.cleanupInterval || 30000; // 30 Seconds
        var itemTTL = options.itemTTL || 60 * 1000; // 60 Seconds

        this.setHeaderAndGetValue = setHeaderAndGetValue;
        this.updateCache = updateCache;
        this.canUseCachedValue = canUseCachedValue;
        this.clearAll = clearAll;
        this._httpHeader = "X-Octopus-Cache-ETag";
        this._cache = {};

        setInterval(ttlPressureCleanup, cleanupInterval);

        function clearAll() {
            self._cache = {};
        }

        function setHeaderAndGetValue(request, options) {
            if (self._cache[options.url]) {
                request.setRequestHeader(self._httpHeader, self._cache[options.url].etag);
                self._cache[options.url].lastAccessed = new Date();
                return self._cache[options.url].value;
            }
        }

        function memoryPressureCleanup(){
            var currentMemory = roughSizeOfReleasableMemory();
            while(currentMemory >= maxMemory) {
                removeOldest();
                newMemoryLevel = roughSizeOfReleasableMemory();
                if(newMemoryLevel === currentMemory) { // Just make sure we don't get stuck.
                    return;
                }
                currentMemory = newMemoryLevel;
            }
        }

        function itemSizeInMemory(url, item){
            return url.length + item.value.length;
        }

        function ttlPressureCleanup() {
            var now = new Date();
            Object.keys(self._cache).forEach(function (url) {
                if((now - self._cache[url].lastAccessed) > itemTTL)
                    delete self._cache[url];
            });
        }

        function removeOldest() {
            var earliestIndex = -1;
            var earliestResponded = -1;
            var now = new Date();

            Object.keys(self._cache).forEach(function(url){
                var age = (now - self._cache[url].lastAccessed);
                if(age > earliestResponded){
                    earliestResponded = age;
                    earliestIndex = url;
                }
            });

            delete self._cache[earliestIndex];
        }

        function roughSizeOfReleasableMemory() {
            return Object.keys(self._cache).reduce(function(total, url) {
                var item = self._cache[url];
                return total + itemSizeInMemory(url, item);
            }, 0);
        }

        function updateCache(request, options) {
            try {
                var etag = request.getResponseHeader(self._httpHeader);
                if (!!etag) {
                    var item = {
                        lastAccessed: new Date(),
                        value: request.responseText,
                        etag: etag
                    };

                    if(itemSizeInMemory(options.url, item) < maxMemory) {
                        self._cache[options.url] = item;
                    }

                    memoryPressureCleanup();
                } else {
                    delete self._cache[options.url];
                }
            } catch (e) {
                delete self._cache[options.url];
            }
        }

        function canUseCachedValue(request) {
            return (request.status === 304 && (request.responseText === "" || !request.responseText));
        }
    };

    Octopus.Client.Util.ajax.cache =  new Octopus.Client.HttpCaching();
    module.exports = Octopus.Client;

})(window);



//////////////////
// WEBPACK FOOTER
// ./app/octopus.client.js
// module id = 1710620532462533
// module chunks = 1